import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Footer from "./Footer";

const navLinks = [
  { label: "Inicio", to: "/" },
  { label: "Soporte", to: "/soporte" },
  { label: "Contacto", to: "/contacto" },
  { label: "Privacidad", to: "/privacidad" },
];

const SitePageLayout = ({ eyebrow, title, description, children }) => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-50 glass border-b border-white/20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center gap-3" aria-label="Ir al inicio">
              <img
                src="/logo1.png"
                alt="Apedir"
                className="h-12 md:h-14 w-auto object-contain"
              />
            </Link>

            <nav className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="nav-link text-foreground font-medium hover:text-primary transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <Link
              to="/contacto"
              className="hidden md:inline-flex items-center justify-center rounded-full bg-primary px-6 py-2 text-sm font-semibold text-white transition-all duration-300 hover:scale-105 hover:bg-primary/90"
            >
              Escribenos
            </Link>
          </div>
        </div>
      </header>

      <main className="pb-16">
        <section className="hero-pattern border-b border-border/60">
          <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="max-w-3xl"
            >
              <span className="inline-flex rounded-full bg-primary/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-primary">
                {eyebrow}
              </span>
              <h1 className="mt-5 text-4xl md:text-5xl font-black tracking-tight">
                {title}
              </h1>
              <p className="mt-4 text-base md:text-lg leading-relaxed text-muted-foreground">
                {description}
              </p>
            </motion.div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
          {children}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default SitePageLayout;
